import { api } from 'shared';
import { z } from 'zod';

export const BestImagesGroupResponseSchema = z.object({
    data: z.object({
        images: z.array(
            z.object({
                url: z.string(),
            }),
        ).optional().nullable(),
    }),
});
export const fetchBestImagesGroup = async () => (
    api.get<z.infer<typeof BestImagesGroupResponseSchema>>(
        '/best-images-group',
        {
            populate: {
                images: {
                    fields: 'url',
                },
            },
        },
        BestImagesGroupResponseSchema,
    )
);
